export default __webpack_public_path__ + "static/media/male_fat_percent.d99df13f.png";